import { TouchableOpacity, Image } from "react-native";

import { bonusGamesModalStyles } from "./styles";
import { BonusGInfoBtn } from "../../../../assets";

interface IProps {
  isSmall: boolean;
  onPress?: () => void;
}

function BGInfoButton({ isSmall, onPress }: IProps) {
  return (
    <TouchableOpacity
      onPress={onPress}
      activeOpacity={0.7}
      style={{
        ...bonusGamesModalStyles.buttons,
        top: isSmall ? -20 : -18,
        left: isSmall ? -2 : 20,
        width: isSmall ? 30 : 22,
        height: isSmall ? 30 : 22,
        transform: [{ scale: isSmall ? 1.4 : 1.4 }],
      }}
    >
      <Image source={BonusGInfoBtn} style={{ width: "100%", height: "100%" }} />
    </TouchableOpacity>
  );
}

export default BGInfoButton;
